import React, { useState } from "react";
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    IconButton, Stack,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { setNewNotification } from "../common/notificationSlice";
import { useDispatch } from "react-redux";
import { LassoTab, LassoTabs } from "../../components/LassoTabs";

const CliInstructions = () => {
    const dispatch = useDispatch()
    const [currentSection, setCurrentSection] = useState("pipx")

    const handleCopy = () => {
        navigator.clipboard.writeText("pip install lasso-cli");
        dispatch(setNewNotification({
            message: "Copied to clipboard",
            type: "success"
        }))
    };

    const handleTabChange = (event: React.SyntheticEvent, newTab: string) => {
        setCurrentSection(newTab)
    }

    return (
        <Stack flexDirection="column" gap={2}>
            <Typography variant="h4"  fontWeight="600" gutterBottom>
                Installing CLI Tool
            </Typography>
            <Typography variant="body1" fontWeight="600" gutterBottom>
                The Lasso CLI is available as a python package from PyPI. It can be installed with pipx or pip.
            </Typography>
            <Typography>
                We enthusiastically recommend using <a href="https://pipx.pypa.io/stable/">pipx</a> to install the Lasso CLI.
                It provides an isolated environment to keep your CLI installation running smoothly, and it’s resilient to changes in your system’s python installation.
            </Typography>

            <LassoTabs value={currentSection}  onChange={handleTabChange}>
                <LassoTab label="pipx" value="pipx"/>
                <LassoTab label="pip" value="pip"/>
            </LassoTabs>

            <Stack gap={2}>
                {currentSection === "pipx" &&
                    <Stack>
                        <Accordion defaultExpanded>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography fontWeight="600">1. Ensure pipx is installed on your machine.</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Stack flexDirection="row" justifyContent="space-between">
                                    <Stack flexDirection="column" marginLeft="10px" marginTop="5px" marginBottom="5px" justifyContent="center">
                                        <Typography variant="body2">Follow the instructions found <a href="https://pipx.pypa.io/stable/installation/">here</a> to install pipx</Typography>
                                    </Stack>
                                </Stack>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion defaultExpanded>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography fontWeight="600">2. Install via pipx.</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Stack flexDirection="row" justifyContent="space-between">
                                    <Stack flexDirection="column" marginLeft="10px" justifyContent="center">
                                        <Typography variant="body2">pipx install lasso-cli</Typography>
                                    </Stack>
                                    <IconButton onClick={handleCopy}>
                                        <ContentCopyIcon />
                                    </IconButton>
                                </Stack>
                            </AccordionDetails>
                        </Accordion>
                    </Stack>}

                {currentSection === "pip" &&
                    <Stack>

                        <Accordion defaultExpanded>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography fontWeight="600">1. Ensure pip is installed on your machine.</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Stack flexDirection="row" justifyContent="space-between">
                                    <Stack flexDirection="column" marginLeft="10px" marginTop="5px" marginBottom="5px" justifyContent="center">
                                        <Typography variant="body2">Pip in installed automatically when Python is installed find
                                            details <a href="https://packaging.python.org/en/latest/tutorials/installing-packages/">here</a> on how to check
                                        if it installed correctly</Typography>
                                    </Stack>
                                </Stack>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion defaultExpanded>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography fontWeight="600">2. Install via pip.</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Stack flexDirection="row" justifyContent="space-between">
                                    <Stack flexDirection="column" marginLeft="10px" justifyContent="center">
                                        <Typography variant="body2">pip install lasso-cli</Typography>
                                    </Stack>
                                    <IconButton onClick={handleCopy}>
                                        <ContentCopyIcon />
                                    </IconButton>
                                </Stack>
                            </AccordionDetails>
                        </Accordion>
                    </Stack>}

            </Stack>
        </Stack>
    );
};

export default CliInstructions